/* eslint-disable @typescript-eslint/no-explicit-any */

import { type JSX,useEffect } from "react";

import { useOktaAuth } from "@okta/okta-react";

import { SplashLoader } from "../../components";
import { withAPIService } from "../../networking";
import { logoutAndRedirectToLogin } from "../../utils/auth/logout";

interface Props {
  apiService: any;
}

function Component({ apiService }: Props): JSX.Element {
  const { oktaAuth } = useOktaAuth();

  useEffect(() => {
    apiService.revokeToken().finally(() => {
      logoutAndRedirectToLogin(oktaAuth);
    });
  }, [oktaAuth, apiService]);

  return <SplashLoader />;
}

// Injecting APIClient to component from APIContext to use it as props
export default withAPIService(Component);
